import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
    { label: "Capabilities", href: "#services" },
    { label: "Doctrine", href: "#manifesto" },
    { label: "Metrics", href: "#stats" },
    { label: "Contact", href: "#contact" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.header
            data-testid="main-navbar"
            initial={{ y: -80 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
                scrolled ? "bg-abyss/90 backdrop-blur-md border-b border-border" : "bg-transparent"
            }`}
        >
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-20 flex items-center justify-between">
                <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
                    <span className="h-9 w-9 bg-safety flex items-center justify-center font-heading font-black text-white text-lg">
                        K
                    </span>
                    <span className="font-heading font-extrabold tracking-tight text-lg text-foreground">
                        KEVA<span className="text-steel font-medium"> SERVICE</span>
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-9">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-${l.label.toLowerCase()}`}
                            className="font-mono-tech text-xs uppercase tracking-[0.2em] text-steel hover:text-foreground transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="#contact"
                    data-testid="nav-cta"
                    className="font-mono-tech text-xs uppercase tracking-[0.15em] bg-safety hover:bg-safety-hover text-white px-5 py-3 transition-colors"
                >
                    Request Assessment
                </a>
            </div>
        </motion.header>
    );
}
